import { AppointmentListItem } from 'src/models/appointmentList';
import { AbstractCommand } from 'src/models/command';

class ChangeAppointmentTimesCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_ChangeAppointmentTimes';
	readonly processId = 'random';

	public constructor(appointment: AppointmentListItem, startDate: Date, endDate: Date) {
		super();

		const currentTime = startDate.getTime();
		const localOffset = -1 * startDate.getTimezoneOffset() * 60000;
		const timestamp = Math.round(new Date(currentTime + localOffset).getTime() / 1000);

		this.parameters = {
			appointmentId: appointment.appointmentId,
			duration: (endDate.getTime() - startDate.getTime()) / 60000,

			startTimestamp: timestamp,
		};
	}
}

export { ChangeAppointmentTimesCommand };
